import React from 'react'
import { 
    CellBody, Form, FormCell, Button,
    Toast, Dialog, Input, Toptips
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelEditPage.css'


class ChannelEditExpectedLecturesPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isPending: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            expectedLectures: '',
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/channel/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    expectedLectures: res.data.data.channel.expected_lectures || '0',
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        if (this.state.isInputError) {
            this.setState({ alertDialog: { isShow: false } })
        } else {
            browserHistory.go(-1)
        }
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    verify () {
        let { expectedLectures } = this.state
        expectedLectures += ''
        if (expectedLectures.trim() === '' || !/^\d+$/.test(expectedLectures) || +expectedLectures < 1) {
            return { status: false, msg: '预计更新须填大于等于1的整数' }
        }
        return { status: true }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true })
        let { expectedLectures } = this.state
        expectedLectures += ''
        axios.post(`/api/channel/${this.props.params.id}/edit`, qs.stringify({
            expected_lectures: +expectedLectures.trim(),
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '修改成功' }
                })
            })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="priority-page">
                        <Header title='预计更新' />
                        <Form>
                            <FormCell>
                                <CellBody>
                                    <Input 
                                        type="number" 
                                        pattern='[0-9]*'
                                        placeholder="" 
                                        value={this.state.expectedLectures} 
                                        onChange={e => this.bindValue(e, 'expectedLectures')} 
                                        className='text-right'
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="intro">请填写本专栏内预计更新的课程数量</p>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditExpectedLecturesPage


// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditExpectedLecturesPage.js